import { ResizeImageResult } from 'helpers';

export type CreateEventPrefillState = {
  groupId?: string;
  categoryIds?: string[];
  coverPhotoUrl?: string;
};

export function coverPhotoFromUrl(url: string): ResizeImageResult {
  return { url, blob: null };
}

/** Use existing upload blob or fetch remote/default cover URL for create mutation. */
export async function resolveCoverPhotoBlob(
  coverPhoto?: ResizeImageResult,
): Promise<Blob | File | null | undefined> {
  if (coverPhoto?.blob) {
    return coverPhoto.blob;
  }
  if (!coverPhoto?.url) {
    return undefined;
  }
  const response = await fetch(coverPhoto.url);
  const blob = await response.blob();
  const extension = coverPhoto.url.split('.').pop()?.split('?')[0] || 'jpg';
  return new File([blob], `event-cover.${extension}`, { type: blob.type || 'image/jpeg' });
}
